import { render, staticRenderFns } from "./MainNavAvatar.vue?vue&type=template&id=f9a00eb8&scoped=true&"
import script from "./MainNavAvatar.vue?vue&type=script&lang=js&"
export * from "./MainNavAvatar.vue?vue&type=script&lang=js&"
import style0 from "./MainNavAvatar.vue?vue&type=style&index=0&id=f9a00eb8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a00eb8",
  null
  
)

export default component.exports